export const isIsUngated = value => {
  return typeof value === 'function' && typeof value('') === 'boolean';
};